'use strict'

export var config = {
//  spaceID: "od09thh3aiwm"
//  ,accessToken:"14bc01f8fd60b2c6fdd5303b085da32574b69a211bc4592ee22cdc38cb9b7fa2"
//  ,configEntryID: "2ZFTDKKncI4mOWCOqoiwWO"
//  ,entryID: "szJhOg0HU4G42GoyQkEWm"
    mars: {
        apiHost: window.location.host
    }
};



// WEBPACK FOOTER //
// ./client/apps/dnareport/app.config.js